import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if credentials are stored
    const credentials = localStorage.getItem('adminCredentials');
    if (credentials) {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const login = async (username, password) => {
    const API = process.env.REACT_APP_BACKEND_URL 
      ? `${process.env.REACT_APP_BACKEND_URL}/api` 
      : '/api';
    
    try {
      const response = await fetch(`${API}/admin/login`, {
        method: 'POST',
        headers: {
          'Authorization': 'Basic ' + btoa(`${username}:${password}`),
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        localStorage.setItem('adminCredentials', btoa(`${username}:${password}`));
        setIsAuthenticated(true);
        return { success: true };
      } else {
        return { success: false, error: 'Identifiants incorrects' };
      }
    } catch (error) {
      return { success: false, error: 'Erreur de connexion au serveur' };
    }
  };

  const logout = () => {
    localStorage.removeItem('adminCredentials');
    setIsAuthenticated(false);
  };

  const getAuthHeader = () => {
    const credentials = localStorage.getItem('adminCredentials');
    return credentials ? `Basic ${credentials}` : '';
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, isLoading, login, logout, getAuthHeader }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
